/** Ribbon — a calligraphic stroke from a fixed pen-nib angle. */
import type { CreateModule } from '../../core/module-api';
import { cfgNum } from '../../core/module-api';
import type { Point } from '../../core/scene';
import { defaultStyle } from '../../core/scene';
import { distance, nibOutline } from '../../core/geometry';

const ICON =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 19 19 5"/><path d="M7 17l3 3"/><path d="M14 4l3 3"/></svg>';

export function createRibbon(): CreateModule {
  let pts: Point[] = [];
  let drawing = false;

  return {
    manifest: {
      id: 'ribbon',
      kind: 'create',
      name: 'Ribbon',
      apiVersion: 1,
      description: 'A calligraphic ribbon — thick and thin from a fixed nib angle.',
      icon: ICON,
      params: [
        { kind: 'slider', key: 'angle', label: 'Nib', min: 0, max: 180, step: 5, default: 45 },
        { kind: 'slider', key: 'width', label: 'Width', min: 4, max: 60, step: 1, default: 22 },
      ],
    },

    onPointerDown(s) {
      pts = [{ x: s.x, y: s.y }];
      drawing = true;
    },

    onPointerMove(s) {
      if (!drawing) return;
      const p = { x: s.x, y: s.y };
      const last = pts[pts.length - 1];
      if (!last || distance(last, p) >= 1.5) pts.push(p);
    },

    onPointerUp() {
      drawing = false;
    },

    getLiveShapes(ctx) {
      if (pts.length === 0) return [];
      const angle = (cfgNum(ctx.config, 'angle', 45) * Math.PI) / 180;
      const width = cfgNum(ctx.config, 'width', 22);
      const style = defaultStyle();
      style.mode = 'fill';
      style.color = { ...ctx.ink };
      const path = nibOutline(pts, Math.cos(angle), Math.sin(angle), width);
      return [ctx.newShape({ path, style })];
    },

    onClear() {
      pts = [];
    },

    onCommit() {
      pts = [];
    },
  };
}
